import { Pagination as CSDPagination } from "@cloudscape-design/components-themed";
import { getPagedItems } from "../../utils/common";

interface PaginationProps {
  currentPageIndex: number;
  filteredItems: Object[];
  setCurrentPageIndex: Function;
  pageSize: number;
  setPagedItems: Function;
}

const Pagination = ({
  currentPageIndex,
  filteredItems,
  setCurrentPageIndex,
  pageSize,
  setPagedItems,
}: PaginationProps): JSX.Element => {
  return (
    <CSDPagination
      currentPageIndex={currentPageIndex}
      pagesCount={Math.ceil(filteredItems.length / pageSize)}
      onChange={({ detail }) => {
        const currentPage = detail.currentPageIndex;
        setCurrentPageIndex(currentPage);
        setPagedItems(getPagedItems(filteredItems, currentPage, pageSize));
      }}
    />
  );
};

export default Pagination;
